import Select from '@atoms/Select/Select';
import VariantTypeEnum from '@models/enums/VariantTypeEnum';
import { IFilter } from '@models/IFilterGroup';
import { useFormContext } from 'react-hook-form';

export interface ISelectInputField {
  readonly name: string;
  readonly label: string;
  readonly options: IFilter[];
  readonly requiredMessage?: string;
  readonly placeholder: string;
  readonly defaultValue?: string;
}

const SelectInputField = ({ requiredMessage, ...rest }: ISelectInputField) => {
  const {
    formState: { errors },
    register,
    setValue,
  } = useFormContext();
  return (
    <Select
      {...rest}
      className="tw-text-sm"
      register={register}
      setValue={setValue}
      requiredErrorMessage={requiredMessage}
      displayLabel={true}
      required={!!requiredMessage}
      errors={errors}
      variant={VariantTypeEnum.Primary}
      fullWidthDropdown
    />
  );
};

export default SelectInputField;
